export interface WalletAccount {
  address: string;
  chainId: number;
  name?: string;
  balance?: string;
  logoUrl?: string;
}

export enum WalletAdapterStatus {
  DISCONNECTED = "disconnected",
  CONNECTING = "connecting",
  CONNECTED = "connected",
  ERROR = "error",
}

export interface TransactionRequest {
  to: string;
  value?: string;
  data?: string;
  chainId?: number;
}

export interface TransactionResponse {
  hash: string;
  chainId: number;
}
